// hooks/useHiddenVerticals.js — verticales que ESTE usuario no debe ver en la app de ventas
// (1/10/2026, orden de David: «Trini no ve NADA de autoescuelas»).
//
// El servidor manda la lista en GET /ventas/settings/access → `hidden_verticals` (clave base, p. ej.
// "autoescuela"; sale de settings.demo_routing.<vertical>.hide_from, sin redeploy). Esto solo
// esconde OPCIONES de la interfaz (selectores de sector, tutoriales, chips de Flow…): los datos
// (leads, tareas, demos, chats, avisos) ya los filtra el servidor, nunca dependen de este hook.
import { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";

/** "Autoescuelas" / "driving_school" → "autoescuela". Espejo de baseVertical (_shared_demo/demoRouting.js). */
export function baseVertical(v) {
  let s = String(v == null ? "" : v).trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  if (!s) return "";
  if (["driving-school", "driving_school", "drivingschool"].includes(s)) return "autoescuela";
  s = s.replace(/[\s_]+/g, "-");
  return s.length > 4 && s.endsWith("s") ? s.slice(0, -1) : s;
}

/** ¿Este sector / categoría está oculto para el usuario? */
export function isHiddenVertical(sector, hidden) {
  if (!hidden || !hidden.length) return false;
  const b = baseVertical(sector);
  return !!b && hidden.some((h) => baseVertical(h) === b);
}

/** Quita de una lista de sectores (strings o {id}) los ocultos. Sin ocultos devuelve la misma lista. */
export function withoutHiddenSectors(list, hidden, getId = (x) => (x && typeof x === "object" ? x.id : x)) {
  if (!hidden || !hidden.length || !Array.isArray(list)) return list;
  return list.filter((x) => !isHiddenVertical(getId(x), hidden));
}

let cache = null; // Promise<string[]> compartida por toda la sesión de la pestaña

function load() {
  if (!cache) {
    cache = Promise.resolve()
      .then(() => axiosClient.get("/ventas/settings/access"))
      .then((data) => (Array.isArray(data?.hidden_verticals) ? data.hidden_verticals : []))
      .catch(() => { cache = null; return []; }); // sin lectura: nada oculto en la UI (el servidor sigue filtrando)
  }
  return cache;
}

/** Test/logout: olvida la lista cacheada. */
export function resetHiddenVerticals() { cache = null; }

export default function useHiddenVerticals() {
  const [hidden, setHidden] = useState([]);
  useEffect(() => {
    let vivo = true;
    load().then((h) => { if (vivo) setHidden(h); });
    return () => { vivo = false; };
  }, []);
  return hidden;
}
